import { FC } from 'react';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import styles from './UncreditedPaymentItem.module.scss';
import { UncreditedPaymentItem as UncreditedPaymentItemType } from 'redux/Api/uncreditedPaymentsApi/type';

export const UncreditedPaymentItem: FC<{ payment: UncreditedPaymentItemType }> = ({
  payment,
}) => {
  return (
    <div className={styles.root}>
      <p className={styles.root_item__standart}>{payment.id}</p>
      <p className={styles.root_item__standart}>{payment.uuid}</p>
      <div className={styles.root_item} style={{ display: 'inline-flex' }}>
        <p>
          {payment.paid_date} {payment.paid_time}
        </p>
      </div>
      <div className={styles.root_item}>
        <p>{payment.purpose}</p>
      </div>
      <div className={styles.root_item}>
        <p>{payment.payer.name}</p>
        <p className={styles.root_item_small}>ИНН: {payment.payer.inn}</p>
        <p className={styles.root_item_small}>БАНК: {payment.payer.bank_name}</p>
      </div>
      <div className={styles.root_item} style={{ textAlign: 'end' }}>
        <p>{addSpaceNumber(payment.amount)}</p>
      </div>
    </div>
  );
};
